import { createContext } from "react";
//Context provides a way to pass data through the component tree without having to pass props explicitly at every level
const Context = createContext(null)

export default Context
